type OrderableProduct = {
  status?: string | null;
  variants?: Array<{ id?: string | null }> | null;
};

type ProductAvailability =
  | { kind: "loading" }
  | { kind: "technical_error" }
  | { kind: "unavailable" }
  | { kind: "orderable" };

export const isProductOrderable = (
  product: OrderableProduct | null | undefined
): boolean =>
  product?.status === "published" &&
  Boolean(product.variants?.some((variant) => Boolean(variant.id)));

export const resolveProductAvailability = ({
  product,
  isLoading,
  isError,
}: {
  product: OrderableProduct | null | undefined;
  isLoading: boolean;
  isError: boolean;
}): ProductAvailability => {
  if (isLoading) return { kind: "loading" };
  if (isError) return { kind: "technical_error" };
  if (!isProductOrderable(product)) return { kind: "unavailable" };
  return { kind: "orderable" };
};
